import AboutOne from "./AboutOne";
import AboutTwo from "./AboutTwo";
import AboutThree from "./AboutThree";

export default function About() {
  return (
    <main className="position-relative bg-light py-5 ">
      <AboutOne />
      <AboutTwo />
      <AboutThree />
      {/* <Team /> */}
      {/* <Cta /> */}
    </main>
  );
}


